import {orderDirectoryTerms} from './directoryOrder.js';

// Follow the same primary SECTION and saved order as the homepage. Additional
// classifications do not turn the next-term control into a cross-section link.
export function adjacentTerms(terms, catalog, current) {
  if (!current) return {previous: null, next: null};
  const section = orderDirectoryTerms(terms.filter(term => term.category === current.category && !term.deletedAt), catalog);
  const index = section.findIndex(term => term.id === current.id);
  return index < 0 ? {previous: null, next: null} : {
    previous: section[index - 1] || null,
    next: section[index + 1] || null,
  };
}

export function bilingualTermTitle(term) {
  return term.english && term.english !== term.label ? term.english + ' · ' + term.label : term.label;
}
